import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from '@app/_services/request.service';
import { authorityIds, operations, subAuthorities } from '@app/enums';

@Injectable({ providedIn: 'root' })
export class AccountApiService {
  constructor(private REQ: RequestService) {}

  getAccountList(): Observable<any> {
    const qry = {
      params: {},
      user_data: {
        authority: authorityIds.OSMA_ACCOUNT,
        sub_authority: subAuthorities.ACCOUNT.LIST,
        operation: operations.LIST,
        data: 'NA',
        format: 'json',
      },
    };
    return this.REQ.get('osma/account', { query: JSON.stringify(qry) });
  }
}
